import { styled } from "@periplus/ui-library";

export default styled("div")(({ theme }) =>
  theme.unstable_sx({
    display: "flex",
    flexDirection: "column",
    gap: 1,
  })
);
